import { Component, ViewChild } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import {
    BaseState, CreateCredentialsParams, CredentialsCheckerMetadata,
    CredentialExternalInfo, CredentialType, SystemCredentialInfo, SystemCredentialParams
}
    from '@m4u-angular/base/entities/BaseEntities';
import { CredentialActivityEndpoint } from '@m4u-angular/core/endpoints/credential-activity.endpoint';
import { SystemCredentialsEndpoint } from '@m4u-angular/core/endpoints/system-credentials.endpoint';
import { WelcomeMessageConfigDialogComponent }
    from '@m4u-angular/ui/dialogs/welcome-message-config-dialog/welcome-message-config-dialog.component';
import { SystemCredentialsCreationGridComponent } from './system-credentials-creation-grid/system-credentials-creation-grid.component';

export class State extends BaseState {
    AdditionalInfoMetadata: CredentialsCheckerMetadata;
    SelectedRows: CredentialExternalInfo[] = [];
    CredentialTypes: CredentialType[];
    CredentialType: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-system-credentials-creation',
    templateUrl: './system-credentials-creation.component.html',
    styleUrls: ['./system-credentials-creation.component.scss']
})
export class SystemCredentialsCreationComponent extends BasePageComponent<SystemCredentialInfo, State> {
    @ViewChild(WelcomeMessageConfigDialogComponent) dialog: WelcomeMessageConfigDialogComponent;
    @ViewChild(SystemCredentialsCreationGridComponent) grid: SystemCredentialsCreationGridComponent;

    constructor(A: ServiceBagService,
        private credentialActivityEndpoint: CredentialActivityEndpoint,
        private systemCredentialEndpoint: SystemCredentialsEndpoint) {
        super(A, 'SystemCredentialsCreationComponent', SystemCredentialInfo, State);
    }

    protected override OnInitComponent() {
        this.InitState();
        this.LoadDataSource();
        this.Do(this.systemCredentialEndpoint.GetAdditionalInfoMetadata(), false, (response) => {
            this.State.AdditionalInfoMetadata = response.Data;
        });
        this.Do(this.credentialActivityEndpoint.ListCredentialTypes(), false, (response) => {
            this.State.CredentialTypes = response.Entities;
        });
    }

    override OnGetToolbarSettings() {
        return {
            IsAllowFilter: true,
            IsAllowExport: true,
            GridExtender: this.grid?.G
        };
    }

    protected override OnApplyFilter() {
        this.LoadDataSource();
    }

    protected override OnClearFilter() {
        this.State.CredentialType = undefined;
        this.LoadDataSource();
    }

    private LoadDataSource() {
        const request = new SystemCredentialParams();
        request.CredentialType = this.State.CredentialType;
        this.DataSources['Credentials'] = new DataSourceCustomAction((options: DataLoadOptions) => {
            return this.systemCredentialEndpoint.ListCredentialsForCreations(request);
        });

        this.DS['Credentials']?.Reload();
    }

    OnSelectionChanged(event) {
        this.State.SelectedRows = event;
    }

    ShowMessageConfigDialog() {
        this.dialog.ShowDialogShort((data) => {
            const { NotificationDeliveryOption, LanguageID, UserCreationOptionID } = data;
            const params = new CreateCredentialsParams();
            params.Language = LanguageID;
            params.DeliveryOption = NotificationDeliveryOption;
            params.CredentialsForCreation = this.State.SelectedRows;
            params.UserCreationOption = UserCreationOptionID;
            this.Do(this.systemCredentialEndpoint.CreateCredentials(params), false, (data) => {
                this.ReloadComponent();
                this.UI.InfoMessage(`${this.RC('msgSuccess')}: ${data.Data} ${this.RC('lblTimes')}`);
                if (params.CredentialsForCreation?.length === 1) {
                    const creds = params.CredentialsForCreation[0];
                    this.Navigate(['/pages/passwordmanage'], { CredentialID: creds.EntryID , Type: creds.Type });
                }
            });
        });
    }
}
